import { render, staticRenderFns } from "./AdminAdvertiserPopUp.vue?vue&type=template&id=057c28f0&scoped=true"
import script from "./AdminAdvertiserPopUp.vue?vue&type=script&lang=js"
export * from "./AdminAdvertiserPopUp.vue?vue&type=script&lang=js"
import style0 from "./AdminAdvertiserPopUp.vue?vue&type=style&index=0&id=057c28f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c28f0",
  null
  
)

export default component.exports